import React, { useEffect, useState } from "react"
import {
  Container,
  Box,
  Typography,
  Grid,
  Paper,
  Divider,
  Skeleton,
  Chip,
} from "@mui/material"
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth"
import AccessTimeIcon from "@mui/icons-material/AccessTime"
import { useParams } from "react-router-dom"
import { blogsAPI } from "../../../services/blogsAPI"
import RichTextRenderer from "../../../components/RichTextRenderer"
import { getStrapiMedia } from "../../../utils/strapiMedia"
import { Row, Col } from "react-bootstrap"

const BlogDetail = () => {
  const { slug } = useParams()
  const [blog, setBlog] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const data = await blogsAPI.getBlogBySlug(slug)
        setBlog(data)
      } catch (err) {
        console.error("Error fetching blog:", err)
      } finally {
        setLoading(false)
      }
    }
    fetchBlog()
  }, [slug])

  if (loading) {
    return (
      <Container maxWidth='lg'>
        <Skeleton height={80} />
        <Skeleton height={400} sx={{ mb: 4 }} />
        <Skeleton height={300} />
      </Container>
    )
  }

  if (!blog) return null

  return (
    <>
      {/* HERO */}
      <Container maxWidth='lg'>
        <Box
          sx={{
            position: "relative",
            height: { xs: 320, md: 420 },
            mb: 8,
            mt: 8,
            bgcolor: "#f8f8f8",
            p: 2,
          }}
        >
          {blog.image && (
            <Box
              component='img'
              src={getStrapiMedia(blog.image)}
              alt={blog.title}
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          )}
        </Box>
      </Container>
      {/* CONTENT */}
      <Container maxWidth='lg'>
        <Grid container spacing={6}>
          <Box>
            <Typography
              variant='h2'
              sx={{
                // color: "#fff",
                fontWeight: 800,
                mb: 2,
                fontSize: { xs: "2rem", md: "3rem" },
              }}
            >
              {blog.title}
            </Typography>

            {blog.date && (
              <Chip
                icon={<CalendarMonthIcon />}
                label={new Date(blog.date).toLocaleDateString("en-GB")}
                sx={{
                  //   color: "#fff",
                  bgcolor: "rgba(255,255,255,0.2)",
                }}
              />
            )}
          </Box>
          <Row>
            <Col item xs={12} md={8}>
              <Paper
                sx={{
                  p: { xs: 3, md: 5 },
                  borderRadius: 4,
                  backgroundColor: "background.paper",
                }}
              >
                <Box
                  sx={{
                    "& p": {
                      lineHeight: 1.9,
                      fontSize: "1.05rem",
                    },
                  }}
                >
                  <RichTextRenderer content={blog.content} />
                </Box>
              </Paper>
            </Col>

            {/* SIDEBAR */}
            <Col item xs={12} md={4}>
              <Paper
                sx={{
                  p: 4,
                  borderRadius: 4,
                  position: "sticky",
                  top: 100,
                }}
              >
                <Typography variant='h6' fontWeight={700} mb={3}>
                  Article Info
                </Typography>

                <Box display='flex' alignItems='center' gap={1} mb={2}>
                  <CalendarMonthIcon fontSize='small' color='action' />
                  <Typography variant='body2' color='text.secondary'>
                    Published
                  </Typography>
                </Box>
                <Typography fontWeight={600} mb={3}>
                  {blog.date
                    ? new Date(blog.date).toLocaleDateString("en-GB")
                    : "—"}
                </Typography>

                <Divider sx={{ my: 3 }} />

                <Box display='flex' alignItems='center' gap={1} mb={1}>
                  <AccessTimeIcon fontSize='small' color='action' />
                  <Typography variant='body2' color='text.secondary'>
                    Reading time
                  </Typography>
                </Box>
                <Typography fontWeight={600}>~5 min read</Typography>
              </Paper>
            </Col>
          </Row>
        </Grid>
        <br></br>
        <br></br>
        <br></br>
      </Container>
    </>
  )
}

export default BlogDetail
